<template>
  <div>
    <div v-if="showTitle" class="d-flex align-center">
      <Icon :icon="paymentIcon" color="systemWalletGreen" class="mr-4" large />
      <Typography variant="subtitle-1">
        {{ customTitle || `Add a ${paymentLanguage.toLowerCase()}` }}
      </Typography>
    </div>
    <div
      v-if="showBudgetSelector && budgets && (budgets.length !== 1 || !computedBudgetId)"
      class="pt-4 d-flex align-center full-width"
    >
      <BudgetSelector
        :budgets="budgets"
        :loading="loadingBudgets"
        :value="computedBudgetId"
        @input="computedBudgetId = $event"
        :hide-details="true"
        @blur="$emit('blur')"
        class="full-width"
      />
    </div>
    <v-card elevation="0" class="pb-0 mt-4">
      <CustomRewardAmount
        :customEmoji="customEmoji"
        :customAmount="customAmount"
        :cashAward="cashAward"
        :showAddButton="showAddAmountButton"
        :budgetId="computedBudgetId"
        :prefix="prefix"
        :suffix="suffix"
        @select-custom-reward="$emit('select-custom-reward')"
        @update-custom-amount="$emit('update-custom-amount', $event)"
        @update-custom-emoji="$emit('update-custom-emoji', $event)"
        @update-valid-amount="$emit('update-valid-amount', $event)"
      />
    </v-card>
  </div>
</template>

<script>
import Icon from "@/components/generic/Icon.vue";
import Typography from "@/components/generic/Typography.vue";
import BudgetSelector from "@/components/budgets/BudgetSelector.vue";
import CustomRewardAmount from "@/components/recognition/CustomRewardAmount.vue";

export default {
  name: "RewardInputState",
  components: {
    Icon,
    Typography,
    BudgetSelector,
    CustomRewardAmount,
  },
  props: {
    customTitle: {
      type: String,
      default: null,
    },
    paymentIcon: {
      type: String,
      default: "mdi-gift-outline",
    },
    paymentLanguage: {
      type: String,
      default: "Reward",
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    showBudgetSelector: {
      type: Boolean,
      default: false,
    },
    showAddAmountButton: {
      type: Boolean,
      default: false,
    },
    budgets: {
      type: Array,
      default: () => [],
    },
    loadingBudgets: {
      type: Boolean,
      default: false,
    },
    budgetId: {
      type: Number,
      default: null,
    },
    customEmoji: {
      type: String,
      default: null,
    },
    customAmount: {
      type: String,
      default: null,
    },
    cashAward: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    computedBudgetId: {
      get: function () {
        return this.budgetId;
      },
      set: function (newVal) {
        this.$emit("update-budgetId", newVal);
      },
    },
    selectedBudget() {
      if (!this.budgetId || !this.budgets || !this.budgets.length) return null;
      return this.budgets.find((budget) => budget.budgetId === this.budgetId);
    },
    prefix() {
      return this.cashAward ? "$" : "";
    },
    suffix() {
      if (this.cashAward || !this.selectedBudget || !this.selectedBudget.Award) return "";
      return (
        this.selectedBudget.Award.unitPluralAbbreviated ||
        this.selectedBudget.Award.unitPlural ||
        "pts"
      ).toLowerCase();
    },
  },
};
</script>
